import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 24;

@Component({
  selector: 'app-data-model-icon',
  standalone: true,
  templateUrl: './data-model-icon.component.html'
})
export class DataModelIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
